const csatList = {
  trocaMetodoPagamento: "trocaMetodoPagamento@v1",
  acordo: "acordo@v1",
}

export default csatList
